<div class="splashscreen">
    <div class="logo">
        <img src="../../../assets/img/dhaduk-logo.png" />
    </div>
    <div class="bottom-img">
        <img src="../../../assets/img/familyyy.png">
    </div>
</div>